/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Fabien SERRA
 * @date        03/06/2021 12:07
 * @copyright   Copyright (c) 2002-2021 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */
import Modernizr from 'modernizr';

export default class Menu {

    constructor()
    {
        if ( Modernizr.touchevents ) {
            Menu.clickMenu()
        }

        if ( window.matchMedia( "(max-width: 1000px)" ).matches ) {
            Menu.burger();
        }
    }

    static clickMenu(){
        const trigger           = '[data-id="wpiris-menu-item"]';

        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $(this).unbind(e);
        } );
    }
    
    static burger()
    {
        const trigger           = '[data-trigger="wpiris-menu-toggle"]',
              $element          = $( '[data-id="wpiris-menu"]' ),
              elementItem       = '[data-id="wpiris-menu-item"], [data-id="wpiris-menu-item-submenu"]',
              elementItemParent = '[data-id="wpiris-menu-item"].withChildrens > a, [data-id="wpiris-menu-item-submenu"].withChildrens > a',
              triggerMore       = '[data-trigger="wpiris-menu-more"]',
              triggerBack       = '[data-trigger="wpiris-menu-back"]';
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $element.toggleClass( 'open' );
            $( trigger ).toggleClass( 'open' );
            $( 'body' ).toggleClass( 'menuOpen' );
            $( '.submenuActive' ).removeClass( 'submenuActive' );
        } );
        
        $( document ).on( 'click', triggerMore, function ( e ) {
            $( elementItem ).removeClass( 'submenuActive' );
            $( this ).parent().addClass( 'submenuActive' );
        } );
        
        $( document ).on( 'click', triggerBack, function ( e ) {
            $( this ).closest( elementItem ).removeClass( 'submenuActive' );
        } );
        
        $( document ).on( 'click', elementItemParent, function ( e ) {
            e.preventDefault();
            $( elementItem ).removeClass( 'submenuActive' );
            $( this ).parents( elementItem ).addClass( 'submenuActive' );
        } );
    }
}